<template>
    <b-container class="contentcontainer site-detail__backups">
      <b-row class="contentcontainer__head">
        <b-col>
          <h2>{{$t('site.latestbackups')}}</h2>
        </b-col>
        <b-col>
          <div class="actions">
            <button v-on:click="backup(siteDetail.id)" v-if="siteDetail.data.backup_tools_installed && siteDetail.data.can_start_backup && backupProgress === null" class="btn btn--primary">
              {{$t('site.backupnow')}}
            </button>
            <span class="text-smaller" v-if="!siteDetail.data.backup_tools_installed || !siteDetail.data.can_start_backup" v-html="$t('site.pleaseinstalltool')"></span>
            <span class="head-button" v-if="backupProgress !== null">
                <font-awesome-icon :icon="['fal','spinner']" pulse></font-awesome-icon>
                {{ backupProgress }} %
            </span>
          </div>
        </b-col>
      </b-row>
      <hr/>
      <b-row>
        <b-col>
          <div class="info">
            <div v-if="showItems" class="table-responsive-lg">
              <table class="table table--overview">
                <thead>
                <tr>
                  <th>
                    {{$t('site.date')}}
                  </th>

                  <th>
                    {{$t('site.size')}}
                  </th>
                  <th>
                    {{$t('site.profile')}}
                  </th>
                  <th class="text-center">
                    {{$t('site.state')}}
                  </th>
                </tr>
                </thead>

                <tbody>
                <site-detail-backup-item
                  v-for="backup in backups"
                  :key="backup.id"
                  v-bind="backup"
                ></site-detail-backup-item>
                </tbody>

                <tfoot v-show="showPagination">
                <tr>
                  <td colspan="4">
                    <nav class="page navigation">
                      <b-pagination
                        align="center"
                        v-bind:total-rows="total"
                        v-model="currentPage"
                        v-bind:per-page="limit"
                      >
                      </b-pagination>
                    </nav>
                  </td>
                </tr>
                </tfoot>
              </table>
            </div>
            <div v-else class="no-backups">
              <div class="text">
                <h2>
                  {{$t('site.nobackupsdetected')}}
                </h2>
                <p>
                  {{$t('site.whynotmakeabackup')}}
                </p>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
</template>

<script>

import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

import SiteDetailBackupItem from './SiteDetailBackupItem'

export default {

  name: 'BackupSection',

  components: {

    SiteDetailBackupItem
  },

  props: {

    showFullListLink: {
      default: true
    },
    showBackLink: {
      default: false
    },
    limit: {
      default: 5
    },
    showPagination: {
      default: false
    }
  },

  computed: {
    ...mapGetters('progress', [
      'siteBackupProgress'
    ]),

    ...mapState('site', [
      'siteDetail'
    ]),

    showItems () {
      return typeof this.siteDetail.data.backups !== 'undefined' && this.siteDetail.data.backups.length > 0
    },

    backupProgress () {
      return this.siteBackupProgress(this.siteDetail.id)
    },

    total () {
      if (typeof this.siteDetail.data.backups === 'undefined') {
        return 0
      }

      return this.siteDetail.data.backups.length
    },

    backups () {
      if (typeof this.siteDetail.data.backups !== 'undefined' &&
                this.siteDetail.data.backups.length > 0) {
        let odd = true
        let backups = []

        if (this.showPagination) {
          let from = this.limit * (this.currentPage - 1)
          let to = from + this.limit

          if (to > this.total) {
            to = this.total
          }

          backups = this.siteDetail.data.backups.slice(from, to)
        } else {
          backups = this.siteDetail.data.backups.slice(0, this.limit)
        }

        backups.map((e) => {
          e.rowType = 'data'
          e.rowOdd = odd
          odd = !odd
          e.backup_tools = this.siteDetail.data.backup_tools
          e.backup_tools_installed = this.siteDetail.data.backup_tools_installed
        })

        return backups
      }

      return []
    }
  },

  data () {
    return {
      currentPage: 1,
      totalPages: 1
    }
  },

  watch: {},

  methods: {

    ...mapMutations('site', [
      'showSiteDetailPageBackups'
    ]),

    ...mapActions('backup', [
      'backup'
    ]),

    close () {
      this.$emit('close-detail')
    }
  }
}
</script>
